import { useEffect, useState } from 'react';
import { SelectPlus } from 'Components/SelectPlus';
import { useGetLines } from '@features/vehicles/hooks/useVehicles';
import { useDebounce } from '@shared/hooks/useDebounce';

export const SelectLine = ({ brand, model, mode = 'single', onSearch, ...selectProps }) => {
  const [searchText, setSearchText] = useState('');

  // page_size grande: el proveedor viejo pagina por defecto con un lote pequeño, y sin esto
  // la mayoría de referencias reales quedan fuera de la primera página aunque existan.
  const { data, isFetching, isPlaceholderData } = useGetLines({
    brand,
    model,
    searchText,
    pageSize: 200,
  });

  // isPlaceholderData indica que la data corresponde a la consulta anterior (keepPreviousData):
  // se descarta para no ofrecer referencias de otro vehículo mientras llega la consulta nueva.
  const records = isPlaceholderData ? [] : (data?.results ?? []);
  const isLoading = isFetching || isPlaceholderData;

  const debouncedSetSearchText = useDebounce(setSearchText);

  // Al cambiar de marca o modelo se descarta la búsqueda anterior: si no, la consulta del
  // vehículo nuevo se haría con el texto viejo y no traería ninguna referencia.
  useEffect(() => {
    debouncedSetSearchText.cancel?.();
    setSearchText('');
  }, [brand, model]);

  const handleSearch = (newSearchText) => {
    debouncedSetSearchText(newSearchText);
    onSearch?.(newSearchText);
  };

  const isSingleMode = mode === 'single';
  const placeholder = `Seleccionar ${isSingleMode ? 'referencia' : 'referencias'}`;

  const options = records.map((record) => ({
    value: record.line,
    label: record.line,
    record,
  }));

  return (
    <SelectPlus
      // La key fuerza un montaje nuevo por cada marca/modelo: descarta el estado interno del
      // select y garantiza que no queden mezcladas las opciones de la búsqueda anterior.
      key={`${brand}-${model}`}
      mode={mode}
      placeholder={placeholder}
      loading={isLoading}
      options={options}
      onSearch={handleSearch}
      filterOption={false} // Se desactiva filtrado interno, ya que se maneja manualmente
      {...selectProps}
    />
  );
};
